(function () {
  var latestCart = null;

  function withRybbit(cb) {
    if (window.rybbit && typeof window.rybbit.event === "function") return cb();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (window.rybbit && typeof window.rybbit.event === "function") {
        clearInterval(timer);
        cb();
      }
      if (tries > 50) clearInterval(timer);
    }, 100);
  }

  function cartToItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.map(function (item) {
      return {
        item_id: (item.sku || item.variant_id || item.id),
        item_name: item.product_title || item.title,
        item_variant: item.variant_title || null,
        price: (item.final_price != null ? item.final_price : item.price) / 100,
        quantity: item.quantity
      };
    });
  }

  // Keep latest cart from your theme events
  document.addEventListener("cart:updated", function (evt) {
    latestCart = evt && evt.detail && evt.detail.cart ? evt.detail.cart : latestCart;
  });

  document.addEventListener("quick-cart:open", function (evt) {
    latestCart = evt && evt.detail && evt.detail.cart ? evt.detail.cart : latestCart;
  });

  // Fallback: fetch cart if we do not have it yet
  function ensureCart(cb) {
    if (latestCart) return cb(latestCart);
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        latestCart = cart;
        cb(cart);
      })
      .catch(function () { cb(null); });
  }

  // Fire begin_checkout on checkout click (cart page or drawer)
  document.addEventListener("click", function (e) {
    var el = e.target;

    // match common checkout triggers
    var checkoutTrigger =
      el && (
        el.closest('button[name="checkout"]') ||
        el.closest('input[name="checkout"]') ||
        el.closest('a[href*="/checkout"]') ||
        el.closest('button[data-checkout]') ||
        el.closest('[data-action="checkout"]')
      );

    if (!checkoutTrigger) return;

    withRybbit(function () {
      ensureCart(function (cart) {
        if (!cart) return;

        window.rybbit.event("begin_checkout", {
          currency: cart.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
          value: (cart.total_price || 0) / 100,
          items: cartToItems(cart)
        });
      });
    });
  }, true);
})();
